// WhatsApp number comes from admin Settings (E.164, e.g. "+81XXXXXXXXXX"). Empty/invalid → every WhatsApp action is hidden.
export const whatsappUrl = (number, text) => {
  const digits = (number || "").replace(/\D/g, "");
  return /^[1-9]\d{7,14}$/.test(digits) ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}` : null;
};

export const SOCIALS = [["instagram", "Instagram"], ["facebook", "Facebook"], ["youtube", "YouTube"], ["x", "X"], ["tiktok", "TikTok"]];
